// extracted by css-extract-rspack-plugin
export default {"component":"Block-module__component___ispxb"};